import { useBalances } from "../state/balances.js";
import { useSession } from "../state/session.js";
import { useT } from "../i18n/index.js";
import { CreditCounter } from "./CreditCounter.js";
import { formatCompact } from "../ui/Counter.js";
import { Link, navigate } from "../router.js";
import { useWsStatus } from "../api/ws.js";
import { useSocial } from "../social/state.js";
import { useStore } from "../store/state.js";
import { useEvents } from "../events/state.js";
import { allianceBadge, useAlliance } from "../alliance/state.js";
import { RESOURCES } from "@zend/content";
import { AssetIcon } from "../assets/Icon.js";
import { ResourceIcon } from "../assets/gameIcons.js";
import { Navigation } from "./Navigation.js";
import { GmBadge } from "../social/GmBadge.js";

export function TopBar() {
  const t = useT();
  const balances = useBalances((s) => s.balances);
  const vip = useSession((s) => s.vip);
  const account = useSession((s) => s.account);
  const ws = useWsStatus((s) => s.status);
  return (
    <header className="topbar">
      <div className="row" style={{ pointerEvents: "auto", gap: 8 }}>
        <Link to="/app/settings" className="glass row name-chip">
          <AssetIcon id="emote.crown" size={36} alt="" />
          <span className="ellipsis" style={{ padding: "6px 10px", fontWeight: 700 }}>{account?.name ?? ""}</span>
          <GmBadge role={account?.role ?? "player"} />
        </Link>
        <Link to="/app/store/vip" className="glass vip-entry" style={{ padding: "6px 10px", fontSize: 12, color: vip && vip.level > 0 ? "var(--gold)" : "var(--text-dim)", fontWeight: 700 }} data-testid="vip-badge">
          {vip && vip.megaRank > 0 ? t("hud.megavip", { rank: vip.megaRank }) : t("hud.vip", { level: vip?.level ?? 0 })}
        </Link>
        <span title={ws} style={{ width: 8, height: 8, borderRadius: 4, background: ws === "open" ? "var(--success)" : ws === "reconnecting" ? "var(--warn)" : "var(--text-faint)" }} data-testid="ws-dot" />
      </div>
      <div className="grow" />
      <div className="row res-row" style={{ pointerEvents: "auto", gap: 6 }}>
        {RESOURCES.map((resource) => (
          <Link to="/app/inventory" key={resource} className="glass mono res-chip" title={t("inventory.openResource", { resource: t(`res.${resource}`) })}>
            <ResourceIcon resource={resource} size={30} label={t(`res.${resource}`)} />
            <span className="resource-copy"><small>{t(`res.${resource}`)}</small><b data-testid={`res-${resource}`}>{balances ? formatCompact(balances[resource]) : "–"}</b></span>
          </Link>
        ))}
      </div>
      <div style={{ pointerEvents: "auto" }}>
        <CreditCounter />
      </div>
    </header>
  );
}

export function BottomNav({ route }: { route: string }) {
  const unread = useSocial((s) => s.unread);
  const storeBadge = useStore((s) => s.flashCount + s.offerCount);
  const eventBadge = useEvents((s) => (s.claimable ? s.claimable.count : s.attention));
  const allianceCount = useAlliance((s) => allianceBadge(s));
  return <Navigation route={route} badges={{ chat: unread, store: storeBadge, events: eventBadge, alliance: allianceCount }} onNavigate={navigate} />;
}
